export default "__VITE_ASSET__CMVGFIk3__"